import { Outlet } from "react-router-dom";
import Sidebar from '../common/Sidebar'
import Header from '../common/Header'

function RootLayout(){
    return (
        <>
            <div className="main-wrapper d-flex w-100">
                <div className="sidebar-wrapper">
                    <Sidebar />
                </div>
                <div className="main-content">
                    <Header />
                    <Outlet />
                </div>
            </div>
        </>
    )
}
export default RootLayout;